import React from 'react';
import Typewriter from './Typewriter';

export default function WelcomeSection() {
  return (
    <div style={{ margin: '2rem 0' }}>
      <Typewriter />
    </div>
  );
}
